var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": _vm.getTitle(),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    key: _vm.preventKey + 'a',
    staticClass: "content-confirm border-radius"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("候选人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('p', [_c('span', [_vm._v("候选人：" + _vm._s(_vm.confirmInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("性别：" + _vm._s(_vm.getSelectMapText('WB_GENDER', _vm.confirmInfo.gender) || '-'))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("手机号：" + _vm._s(_vm.confirmInfo.phone))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("邮箱：" + _vm._s(_vm.confirmInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("\n          当前职位：" + _vm._s(_vm.confirmInfo.position)), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("最高学历学校：" + _vm._s(_vm.confirmInfo.school))])])])], 1)], 1), _vm._v(" "), _c("el-form", {
    key: _vm.preventKey + 'b',
    ref: "ruleForm",
    tag: "el-form",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', [_c('user-search', {
    ref: "managerSelect",
    attrs: {
      "holder": "主管",
      "multiple": false
    },
    model: {
      value: (_vm.ruleForm.managerId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "managerId", $$v)
      },
      expression: "ruleForm.managerId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b91de1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/managerEditDialog.vue
// module id = null
// module chunks = 